import React from 'react';
import AnalysisTextSection from './AnalysisTextSection';
import { Registry } from '@/graphql/__generated__/onboarding-legal';
import { useNormalizedAntifraudData } from '@/hooks/useNormalizedAntifraudData';

interface CurpProps {
	registry: Registry;
}

export const Curp: React.FC<CurpProps> = ({ registry }) => {
	const normalizedData = useNormalizedAntifraudData(registry);

	const getExistsInRenapo = (): boolean | null => {
		if (!normalizedData?.curp) return null;

		if (normalizedData.curp.error) {
			return false;
		}
		if (normalizedData.curp.isValid === true) {
			return true;
		}
		if (normalizedData.curp.isValid === false) {
			return false;
		}
		return null;
	};

	const existsInRenapo = getExistsInRenapo();

	return (
		<div className="space-y-3">
			<AnalysisTextSection label="CURP" value={normalizedData?.curp?.curp} />
			<AnalysisTextSection label="DateOfBirth" value={normalizedData?.curp?.dateOfBirth} />
			<AnalysisTextSection label="Gender" value={normalizedData?.curp?.gender} />
			<AnalysisTextSection label="GovernmentName" value={normalizedData?.curp?.governmentName} />
			<AnalysisTextSection label="IsMexican" value={normalizedData?.curp?.isMexican} />
			<AnalysisTextSection label="IsValid" value={normalizedData?.curp?.isValid} />
			{existsInRenapo !== null && (
				<AnalysisTextSection label="ExistsInRenapo" value={existsInRenapo} />
			)}
		</div>
	);
};

export default Curp;
